import { render, staticRenderFns } from "./CommentPhotoNote.vue?vue&type=template&id=46133490&"
import script from "./CommentPhotoNote.vue?vue&type=script&lang=js&"
export * from "./CommentPhotoNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports